import { gql } from 'graphql-request';
import { getContentStackLang } from 'src/utils';
import { ILocaleReq } from './core';
import { graphQLClient } from './index';

export const TRANSLATION_KEYS = {
  READ_TIME: 'READ_TIME',
  TOTAL_ITEM: 'TOTAL_ITEM',
};

const translationQuery = ({ locale }: ILocaleReq) => {
  locale = getContentStackLang(locale);
  return gql`
  query MyQuery {
    meta_translations(uid: "blt97047cda9b0daec8", locale: "${locale}") {
      translations {
        key
        value
      }
    }
  }
`;
};

export const getTranslationData = async (req: ILocaleReq) => {
  const data = await graphQLClient.request(translationQuery(req));
  const translations = data?.meta_translations?.translations;
  let translation = {};
  translations.forEach((pair) => {
    translation[pair.key] = pair.value;
  });
  return translation;
};

let translationData = {};

export const buildTranslation = async ({ locale }: ILocaleReq) => {
  if (!translationData[locale]) {
    const sessionKey = `content-web-translation-${locale}`;
    const transString = window.sessionStorage.getItem(sessionKey);
    if (transString) {
      translationData[locale] = JSON.parse(transString);
    } else {
      const trans = await getTranslationData({
        locale,
      });
      window.sessionStorage.setItem(sessionKey, JSON.stringify(trans));
      translationData[locale] = trans;
    }
  }
};

export const fm = (key, defaultValue = '', locale = 'en'): string => {
  if (translationData[locale]) {
    return translationData[locale][key] ?? defaultValue;
  }
  return '';
};
